import React from 'react'; 
import PropTypes from 'prop-types';
import clone from 'clone';
import CustomEvent from 'custom-event';

import {connectAppEnv} from '../app/app-env';
import {addModuleEnv} from './oe-module-env';
import {oeInterfaceManager} from '../react-oe/oe-interface';
import OEInterfaceAdapter from '../react-oe/oe-interface-adapter';
import {OEShowInitiallyFlags, UILevel} from '../lib/oe-types';
import {translateToUILevel} from '../lib/react/oe-higher-order-components';
import OEResizeObserver from '../lib/components/oe-resize-observer';
import NotificationCenter from '../lib/notification/notification-center';
import retardUpdate from '../lib/react/update-retarder';
import OEToolbox from '../lib/tools/oe-toolbox';
import OEAnimateHelper from '../lib/animation/oe-animate-helper';
import {OEDefaultConfigFactory} from './oe-default-configs';
import OELeftWidgetToolbar from './bars/oe-left-widget-toolbar';
import OEBottomWidgetToolbar from './bars/bottom/oe-bottom-widget-toolbar';
import {OEMainMenuStdBtnType} from './bars/main-menu/oe-main-menu-model';
import OEMainMenu from './bars/main-menu/oe-main-menu';
import OEContextMenu from './controller/context-menu/oe-context-menu';
import OELabelController from './controller/oe-label-controller';
import OECutController from './controller/oe-cut-controller';
import OESettingsControllerPopover, {OESecondarySettingsControllerPopover} from './controller/settings/oe-settings-controller-popover';
//import OESettingsControllerView from './controller/settings/oe-settings-controller-view';
import OESubstructureController from './controller/component/oe-substructure-controller';
import OESearchController from './controller/search/oe-search-controller';
import OEPresentationController from './controller/presentation/oe-presentation-controller';
import OENoteController from './controller/notes/oe-note-controller';
import OENotePopoverController from './controller/notes/oe-note-popover-controller';
import OENoteViewerEditPopover from './controller/notes/oe-note-viewer-edit-popover';
import OEArrowController from './controller/arrows/oe-arrow-controller';
import OEArrowPopoverController from './controller/arrows/oe-arrow-popover-controller';
import OEUserObjectController from './controller/user-object/oe-user-object-controller';
import OEUserObjectPopoverController from './controller/user-object/oe-user-object-popover-controller';
import OEScreenshotController from './controller/screenshot/oe-screenshot-controller';
import OETextViewController from './views/text-view/oe-text-view-controller';
import OEStartView from './views/start-view/oe-start-view';
import OEWelcomeView from './views/welcome-view/oe-welcome-view';
import OEInfoViewController from './views/info-view/oe-info-view-controller';
import OEFreePremiumView from './views/free-premium-view/oe-free-premium-view';
import OEHelpView from './views/help-view/oe-help-view';
import OEManualView from './views/manual-view/oe-manual-view';
import OEStartSelectionView from './views/start-selection-view/oe-start-selection-view';
import OEInfoMessageView from './views/info-message-view/oe-info-message-view';
import OECustomExtView from './views/oe-custom-ext-view';
import OEBGLoadingDisplay from './views/oe-bg-loading-display';
import OEMediaCenter from './controller/media-center/oe-media-center';
import OEOverlayContainer from './overlays/oe-overlay-container';
import OEMediaViewerController from './media-viewer/oe-media-viewer-controller';
import OEMediaFunctionFragmentView from './views/oe-media-function-fragment-view';
import {OEBlurCoreLayer, OEBlurUILayer, OEBlurAllLayer} from './views/oe-blur-layer';
import OETutorController from './controller/oe-tutor-controller';
import OEMainMenuControlBar from './bars/oe-main-menu-control-bar';
import OERightTopBar from './bars/right-top/oe-right-top-bar';
import OELogoView from './elements/oe-logo-view';
import OEDevTools from './dev/oe-dev-tools';
import OEOfflineManagerPopover from './pwa/oe-offline-manager-controller';

export class OEUILayer extends React.PureComponent {
    
    constructor(props) {
        super(props);

        this.props.appComponent.uiLayer = this;
        this.notificationCenter = new NotificationCenter();

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.justComponentLongTouched = false;

        this.leftSlideInShown = OEShowInitiallyFlags.resolve(this.props.config.mainMenuConfig.showInitially).show;
        this.leftWidgetToolbarShown = false;

        this.mainMenuWidth = 56;

        this.state = {
            uiLevel:            UILevel.std,
            leftSlideInContainer: {
                width:          250 + this.mainMenuWidth,
                offset:         this.mainMenuWidth,
                animate:        false,
                mainMenuPosX:   250
            },
            mediaCenterEdgeOffsets: {
                top: 0, right: 0, bottom: 0, left: 0,
                animate:        false
            },
            mediaCenterBottomBarEdgeOffsets: {
                top: 0, right: 0, bottom: 0, left: 0,
                animate:        false
            },
            bottomBarWidgetToolbarEdgeOffsets: {
                top: 0, right: 0, bottom: 0, left: 0,
                animate:        false
            },
            bottomBarEdgeOffsets: {
                top: 0, right: 0, bottom: 0, left: 0,
                animate:        false
            },
            bottomEdgeOffset: {
                value:          0,
                animate:        false
            },
            edgeOffsets: {
                top: 0, right: 0, bottom: 0, left: 0,
                animate:        false
            },
            tutorMargin:        46
        };

        this.onLeftSlideContainerTransitioned = this.onLeftSlideContainerTransitioned.bind(this);

        this.onWindowResized = this.onWindowResized.bind(this);

        this.onUILevelChanged = this.onUILevelChanged.bind(this);

        this.onRef = this.onRef.bind(this);
        this.onPresentationControllerRef = this.onPresentationControllerRef.bind(this);
        this.onNotePopoverRef = this.onNotePopoverRef.bind(this);
        this.onNoteViewerEditPopoverRef = this.onNoteViewerEditPopoverRef.bind(this);
        this.onArrowPopoverRef = this.onArrowPopoverRef.bind(this);
        this.onUserObjectPopoverRef = this.onUserObjectPopoverRef.bind(this);
        this.onScreenshotViewRef = this.onScreenshotViewRef.bind(this);
        this.onSecondarySettingsViewRef = this.onSecondarySettingsViewRef.bind(this);
        this.onOfflineManagerViewRef = this.onOfflineManagerViewRef.bind(this);
        this.onTextViewRef = this.onTextViewRef.bind(this);
        this.onStartViewRef = this.onStartViewRef.bind(this);
        this.onWelcomeViewRef = this.onWelcomeViewRef.bind(this);
        this.onInfoViewRef = this.onInfoViewRef.bind(this);
        this.onFreePremiumViewRef = this.onFreePremiumViewRef.bind(this);
        this.onHelpViewRef = this.onHelpViewRef.bind(this);
        this.onManualViewRef = this.onManualViewRef.bind(this);
        this.onStartSelectionViewRef = this.onStartSelectionViewRef.bind(this);
        this.onInfoMessageViewRef = this.onInfoMessageViewRef.bind(this);
        this.onCustomExtViewRef = this.onCustomExtViewRef.bind(this);
        
        this.onMediaCenterEdgeOffsetsChanged = this.onMediaCenterEdgeOffsetsChanged.bind(this);
        this.onMediaCenterBottomBarEdgeOffsetsChanged = this.onMediaCenterBottomBarEdgeOffsetsChanged.bind(this);
        this.onShouldBeVisibleLeftWidgetToolbar = this.onShouldBeVisibleLeftWidgetToolbar.bind(this);
        this.onLeftWidgetToolbarResize = this.onLeftWidgetToolbarResize.bind(this);
        this.onMainMenuSizeChanged = this.onMainMenuSizeChanged.bind(this);
        this.onMainMenuControlBtnPressed = this.onMainMenuControlBtnPressed.bind(this);
        this.onBottomBarWidgetToolbarEdgeOffsetsChanged = this.onBottomBarWidgetToolbarEdgeOffsetsChanged.bind(this);
        this.onPresentationControllerPinnedChanged = this.onPresentationControllerPinnedChanged.bind(this);
    }

    setStateUpdate(spec)   {
        OEToolbox.updateComponentState(this, spec);
    }

    showLeftSlideIn(show, animated)   {
        show = !!show;
        if(show === this.leftSlideInShown) return;
        this.leftSlideInShown = show;
        this.updateLeftSlideInContainer(animated);
    }

    closeAllPopovers(exceptions, exceptUnpinned)  {
        if(this.notePopover)            this.notePopover.close();
        if(this.noteViewerEditPopover)  this.noteViewerEditPopover.close();
        if(this.arrowPopover)           this.arrowPopover.close();
        if(this.userObjectPopover)      this.userObjectPopover.close();
        if(this.screenshotView)         this.screenshotView.close();

        if(!this.oe.isReady())   return;

        let si = this.oe.sharedInterface;
        let UIControllerType = this.oe.Module.UIControllerType;

        let config = this.props.config;
        let widgetConfig = translateToUILevel(config.widgetConfig || OEDefaultConfigFactory.widget(), this.state.uiLevel);
        let array = !exceptions ? [] : (Array.isArray(exceptions) ? exceptions : [exceptions]);

        if(widgetConfig.labelController.enabled && !array.includes(UIControllerType.label))                 si.setUIControllerVisible(false, UIControllerType.label);
        if(widgetConfig.cutController.enabled && !array.includes(UIControllerType.cut))                     si.setUIControllerVisible(false, UIControllerType.cut);
        if(widgetConfig.settingsController.enabled && !array.includes(UIControllerType.settings))           si.setUIControllerVisible(false, UIControllerType.settings);
        if(widgetConfig.substructureController.enabled && !array.includes(UIControllerType.substructure))   si.setUIControllerVisible(false, UIControllerType.substructure);
        if(widgetConfig.searchController.enabled && !array.includes(UIControllerType.search_controller))    si.setUIControllerVisible(false, UIControllerType.search_controller);
        if(widgetConfig.presentationController.enabled && !array.includes(UIControllerType.presentation) && (!exceptUnpinned || !this.presentationController || this.presentationController.getPinned()))   si.setUIControllerVisible(false, UIControllerType.presentation);
        if(widgetConfig.arrowController.enabled && !array.includes(UIControllerType.arrow))                 si.setUIControllerVisible(false, UIControllerType.arrow);
        if(widgetConfig.userObjectController.enabled && !array.includes(UIControllerType.user_object))      si.setUIControllerVisible(false, UIControllerType.user_object);
        if(widgetConfig.noteController.enabled && !array.includes(UIControllerType.note))                   si.setUIControllerVisible(false, UIControllerType.note);
    }

    onLeftSlideContainerTransitioned(event)  {
        let propName = event.originalEvent.propertyName;
        if(event.target !== event.currentTarget || (typeof(propName) === 'string' && propName !== 'left' && propName !== 'width')) return;
        window.dispatchEvent(new CustomEvent('oe-layout-changed'));
    }

    componentDidMount()    {
        this.onWindowResized();
        window.addEventListener('resize', this.onWindowResized);

        let cssTransitionEnd = 'transitionend webkitTransitionEnd otransitionEnd oTransitionEnd msTransitionEnd MSTransitionEnd';
        $('#left-slide-in-container').on(cssTransitionEnd, this.onLeftSlideContainerTransitioned);
    }

    componentWillUnmount()    {
        window.removeEventListener('resize', this.onWindowResized);

        let cssTransitionEnd = 'transitionend webkitTransitionEnd otransitionEnd oTransitionEnd msTransitionEnd MSTransitionEnd';
        $('#left-slide-in-container').off(cssTransitionEnd, this.onLeftSlideContainerTransitioned);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiLevelChanged, this.onUILevelChanged);
    }

    onRelease()  {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiLevelChanged, this.onUILevelChanged);
    }

    onWindowResized()   {
        this.updateLeftSlideInContainer(false);
        this.updateTutorMargin();
    }

    updateState_(released)   {
        let show;
        let resolved = OEShowInitiallyFlags.resolve(this.props.config.mainMenuConfig.showInitially);
        if((!resolved.onlyAtStartUp || !this.showInitiallySet) && (resolved.show || resolved.atTargetChange))   show = resolved.show;
        this.showInitiallySet = true;
        if(show !== undefined)    this.showLeftSlideIn(show, true);

        //
        if(!this.oe.isReady() || released === true)   {
            //this.setState({uiLevel: UILevel.std});     // do not switch back at disconnect, instead wait for new state when connecting
            return;
        }

        this.onUILevelChanged();
    }

    updateState(released)   {
        retardUpdate(this, () => {
            this.updateState_(released);
        });
    }

    onUILevelChanged()  {
        this.setState({
            uiLevel: UILevel.levelFromModuleValue(this.oe.sharedInterface.getUIControllerSettings().getUILevel().value)
        });
    }

    updateTutorMargin() {
        let size = Math.min($(window).width(), $(window).height());
        this.setState({tutorMargin: Math.min(46, size * 0.05)});
    }

    updateLeftSlideInContainer(animated)    {
        if(!this.leftWidgetSizeObserver) return;
        
        const toolbarWidth = this.leftWidgetSizeObserver.getWidth();
        const mainMenuWidth = this.mainMenuWidth;

        let offset = 0;
        let width = toolbarWidth + mainMenuWidth;

        if(this.leftSlideInShown)  {
            offset += mainMenuWidth;
            if(this.leftWidgetToolbarShown)   {
                offset += toolbarWidth;
            }
        }

        const leftSlideInContainer = {
            width: width,
            offset: offset,
            animate: !!animated,
            mainMenuPosX: toolbarWidth
        };

        this.setState((prevState, props) => {
            let state = clone(prevState);
            state.leftSlideInContainer = Object.assign(clone(leftSlideInContainer), {animate: prevState.leftSlideInContainer.animate});

            state.edgeOffsets.left = leftSlideInContainer.offset;

            if(OEToolbox.shallowEqual(state, prevState, true))  return prevState;

            state.leftSlideInContainer.animate = leftSlideInContainer.animate;
            state.edgeOffsets.animate = OEAnimateHelper.update(state.edgeOffsets.animate, {left: leftSlideInContainer.animate});
            return state;
        });

        this.props.moduleEnv.component.uiStateManager.setState((prevState) => {
            let state = clone(prevState);
            state.leftSlideInContainer = Object.assign(clone(leftSlideInContainer), {animate: prevState.leftSlideInContainer.animate});

            state.edgeOffsets.left = leftSlideInContainer.offset;

            if(OEToolbox.shallowEqual(state, prevState, true))  return prevState;

            state.leftSlideInContainer.animate = leftSlideInContainer.animate;
            state.edgeOffsets.animate = leftSlideInContainer.animate;
            return state;
        });
    }

    onRef(ref)   {
        if(this.ref === ref) return;
        this.ref = ref;
        this.forceUpdate();     // we cannot include ref into state, due to clone(prevState) pattern in some state updates
    }

    onPresentationControllerRef(ref)    {
        this.presentationController = ref;
    }

    onNotePopoverRef(ref)   {
        this.notePopover = ref;
    }

    onNoteViewerEditPopoverRef(ref)   {
        this.noteViewerEditPopover = ref;
    }

    onArrowPopoverRef(ref)   {
        this.arrowPopover = ref;
    }

    onUserObjectPopoverRef(ref)   {
        this.userObjectPopover = ref;
    }

    onScreenshotViewRef(ref)  {
        this.screenshotView = ref;
    }

    onSecondarySettingsViewRef(ref) {
        this.secondarySettingsView = ref;
    }

    onOfflineManagerViewRef(ref)    {
        this.offlineManagerView = ref;
    }

    onTextViewRef(ref)  {
        this.textView = ref;
    }
    
    onStartViewRef(ref) {
        this.startView = ref;
    }

    onWelcomeViewRef(ref)   {
        this.welcomeView = ref;
    }

    onInfoViewRef(ref) {
        this.infoView = ref;
    }

    onFreePremiumViewRef(ref)    {
        this.freePremiumView = ref;
    }

    onHelpViewRef(ref)  {
        this.helpView = ref;
    }

    onManualViewRef(ref)  {
        this.manualView = ref;
    }

    onStartSelectionViewRef(ref)    {
        this.startSelectionView = ref;
    }

    onInfoMessageViewRef(ref) {
        this.infoMessageView = ref;
    }

    onCustomExtViewRef(ref) {
        this.customExtView = ref;
    }

    mainMenuButtons()   {
        let config = this.props.config;
        return translateToUILevel(config.mainMenuButtons, this.state.uiLevel);
    }

    hasMainMenuBtn(type)    {
        const btns = this.mainMenuButtons();
        const fn = b => b.type === type;
        return (Array.isArray(btns.top) && btns.top.find(fn)) || (Array.isArray(btns.bottom) && btns.bottom.find(fn)) || (Array.isArray(btns.left) && btns.left.find(fn)) || (Array.isArray(btns.right) && btns.right.find(fn));
    }
    
    render() {
        let id = this.props.moduleId + '-ui-layer';
        let config = this.props.config;

        let leftWidth = this.state.leftSlideInContainer.width;
        let leftLeft = -leftWidth + this.state.leftSlideInContainer.offset;
        let controlButtonLeft = this.state.leftSlideInContainer.offset;

        let popoverControllerProps = {moduleId: this.props.moduleId, boundariesElement: this.ref, uiLevel: this.state.uiLevel};

        let bottomBarEdgeOffsetsAnim = OEAnimateHelper.resolve(this.state.bottomBarEdgeOffsets.animate);
        let edgeOffsetsAnim = OEAnimateHelper.resolve(this.state.edgeOffsets.animate);

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <div 
                    id={id}
                    className={'ui-layer ' + this.props.className}
                    style={this.props.style}
                    ref={this.onRef}
                >
                    <OEBGLoadingDisplay moduleId={this.props.moduleId}/>

                    <OEOverlayContainer
                        moduleId={this.props.moduleId}
                        target={this.props.target}
                        insets={{top: 0, right: this.state.bottomBarEdgeOffsets.right, bottom: this.state.edgeOffsets.bottom, left: this.state.edgeOffsets.left}}
                        animate={{top: false, right: bottomBarEdgeOffsetsAnim.right, bottom: edgeOffsetsAnim.bottom, left: edgeOffsetsAnim.left}}
                        onEdgeOffsetsChanged={this.onOverlayEdgeOffsetsChanged}
                    />

                    {
                    /*
                    <OEMediaViewerController
                        className="test-media-viewer"
                        dataSource={OEMediaViewerController.getTestDataSource()}
                        showControlsWhenWindow={true}
                    />
                    */
                    }

                    {config.hasMediaCenter ? (
                        <OEMediaCenter
                            moduleId={this.props.moduleId}
                            insets={{left: this.state.leftSlideInContainer.offset, animate: {left: this.state.leftSlideInContainer.animate}}}
                            onEdgeOffsetsChanged={this.onMediaCenterEdgeOffsetsChanged}
                            onBottomBarEdgeOffsetsChanged={this.onMediaCenterBottomBarEdgeOffsetsChanged}
                        />
                    ) : null}

                    <div
                        id="left-slide-in-container"
                        className="left-slide-in-container"
                        style={{
                            width: leftWidth.toString() + 'px',
                            left: leftLeft.toString() + 'px',
                            transition: OEAnimateHelper.transitionForInsets({left: this.state.leftSlideInContainer.animate})
                        }}
                    >
                    
                        <OELeftWidgetToolbar
                            uiLevel={this.state.uiLevel}
                            moduleId={this.props.moduleId} 
                            widgetConfig={config.widgetConfig}
                            boundariesElement={this.ref}
                            onShouldBeVisible={this.onShouldBeVisibleLeftWidgetToolbar}
                        >
                            <OEResizeObserver onResize={this.onLeftWidgetToolbarResize} />
                        </OELeftWidgetToolbar>

                        <OEMainMenu
                            moduleId={this.props.moduleId}
                            style={{left: this.state.leftSlideInContainer.mainMenuPosX.toString() + 'px'}}
                            uiLevel={this.state.uiLevel}
                            buttons={config.mainMenuButtons}
                            config={config.mainMenuConfig}
                            onSizeChanged={this.onMainMenuSizeChanged}
                        />
                    
                    </div>
                    
                    <OEMainMenuControlBar
                        moduleId={this.props.moduleId}
                        style={{
                            left: controlButtonLeft.toString() + 'px',
                            transition: OEAnimateHelper.transitionForInsets({left: this.state.leftSlideInContainer.animate})
                        }}
                        onMainMenuControlBtnPressed={this.onMainMenuControlBtnPressed}
                    />

                    <OEBottomWidgetToolbar
                        appComponent={this.props.appComponent}
                        moduleId={this.props.moduleId}
                        insets={{left: this.state.leftSlideInContainer.offset}}
                        animate={this.state.leftSlideInContainer.animate}
                        onEdgeOffsetsChanged={this.onBottomBarWidgetToolbarEdgeOffsetsChanged}
                        config={config.widgetConfig.bottomWidgetToolbar}
                    />

                    <OEContextMenu moduleId={this.props.moduleId}/>

                    {config.disableTutor ? null :
                        <OETutorController
                            moduleId={this.props.moduleId}
                            margin={this.state.tutorMargin}
                        />
                    }

                    {this.hasMainMenuBtn(OEMainMenuStdBtnType.label) ? <OELabelController {...popoverControllerProps} target='mm-label-btn'/> : null}
                    {this.hasMainMenuBtn(OEMainMenuStdBtnType.cut) ? <OECutController {...popoverControllerProps} target='mm-cut-btn'/> : null}
                    {this.hasMainMenuBtn(OEMainMenuStdBtnType.settings) ? <OESettingsControllerPopover {...popoverControllerProps} target='mm-settings-btn'/> : null}
                    {this.hasMainMenuBtn(OEMainMenuStdBtnType.substructure) ? <OESubstructureController {...popoverControllerProps} target='mm-substructure-btn'/> : null}
                    {this.hasMainMenuBtn(OEMainMenuStdBtnType.search) ? <OESearchController {...popoverControllerProps} target='mm-search-btn' /> : null}
                    {this.hasMainMenuBtn(OEMainMenuStdBtnType.presentation) ? <OEPresentationController {...popoverControllerProps} target='mm-presentation-btn' onPinnedChanged={this.onPresentationControllerPinnedChanged} ref={this.onPresentationControllerRef}/> : null}
                    {this.hasMainMenuBtn(OEMainMenuStdBtnType.note) ? <OENoteController {...popoverControllerProps} target='mm-note-btn'/> : null}
                    {this.hasMainMenuBtn(OEMainMenuStdBtnType.arrow) ? <OEArrowController {...popoverControllerProps} target='mm-arrow-btn'/> : null}
                    {this.hasMainMenuBtn(OEMainMenuStdBtnType.userObject) ? <OEUserObjectController {...popoverControllerProps} target='mm-user-object-btn'/> : null}
                    
                    <OENotePopoverController {...popoverControllerProps} ref={this.onNotePopoverRef}/>
                    <OENoteViewerEditPopover {...popoverControllerProps} ref={this.onNoteViewerEditPopoverRef}/>
                    <OEArrowPopoverController {...popoverControllerProps} ref={this.onArrowPopoverRef}/>
                    <OEUserObjectPopoverController {...popoverControllerProps} ref={this.onUserObjectPopoverRef}/>

                    {this.hasMainMenuBtn(OEMainMenuStdBtnType.screenshot) ? <OEScreenshotController ref={this.onScreenshotViewRef} {...popoverControllerProps} target='mm-screenshot-btn'/> : null}

                    {
                        //this.hasMainMenuBtn(OEMainMenuStdBtnType.secondarySettings) ? <OESettingsControllerView moduleId={this.props.moduleId} ref={this.onSecondarySettingsViewRef}/> : null
                        this.hasMainMenuBtn(OEMainMenuStdBtnType.secondarySettings) ? <OESecondarySettingsControllerPopover {...popoverControllerProps} target='mm-secondary-settings-btn' ref={this.onSecondarySettingsViewRef}/> : null
                    }

                    {
                        this.hasMainMenuBtn(OEMainMenuStdBtnType.offlineManager) ? <OEOfflineManagerPopover {...popoverControllerProps} target='mm-offline-manager-btn' ref={this.onOfflineManagerViewRef}/> : null
                    }

                    <OETextViewController ref={this.onTextViewRef} {...popoverControllerProps} target='mm-text-view-btn'/>

                    <OEStartView moduleId={this.props.moduleId} ref={this.onStartViewRef}/>

                    <OEWelcomeView moduleId={this.props.moduleId} ref={this.onWelcomeViewRef}/>

                    <OEInfoViewController
                        appComponent={this.props.appComponent}
                        moduleId={this.props.moduleId}
                        config={config.infoView}
                        ref={this.onInfoViewRef}
                    />

                    <OEFreePremiumView moduleId={this.props.moduleId} ref={this.onFreePremiumViewRef}/>

                    <OEHelpView moduleId={this.props.moduleId} ref={this.onHelpViewRef}/>

                    <OEManualView moduleId={this.props.moduleId} ref={this.onManualViewRef}/>

                    <OEStartSelectionView moduleId={this.props.moduleId} ref={this.onStartSelectionViewRef}/>

                    <OEInfoMessageView moduleId={this.props.moduleId} ref={this.onInfoMessageViewRef}/>

                    <OECustomExtView moduleId={this.props.moduleId} ref={this.onCustomExtViewRef}/>

                    <OERightTopBar
                        moduleId={this.props.moduleId}
                        style={{
                            right: this.state.edgeOffsets.right.toString() + 'px',
                            transition: OEAnimateHelper.transitionForInsets({right: edgeOffsetsAnim.right})
                        }}
                    />

                    <OEDevTools
                        moduleId={this.props.moduleId}
                        style={{
                            right: this.state.edgeOffsets.right.toString() + 'px',
                            bottom: this.state.edgeOffsets.bottom.toString() + 'px',
                            left: this.state.edgeOffsets.left.toString() + 'px',
                            transition: OEAnimateHelper.transitionForInsets({
                                right: edgeOffsetsAnim.right,
                                bottom: edgeOffsetsAnim.bottom,
                                left: edgeOffsetsAnim.left
                            })
                        }}
                    />

                    <OELogoView
                        moduleId={this.props.moduleId}
                        className="company-logo"
                        config={config.logo}
                    />

                    <OEMediaFunctionFragmentView
                        moduleId={this.props.moduleId}
                        ignoreInsets={true}
                        insets={this.state.edgeOffsets}
                        animate={edgeOffsetsAnim}
                    />

                    <OEBlurCoreLayer appComponent={this.props.appComponent} moduleId={this.props.moduleId} radius={8}/>
                    <OEBlurUILayer appComponent={this.props.appComponent} moduleId={this.props.moduleId} radius={8}/>
                    <OEBlurAllLayer appComponent={this.props.appComponent} moduleId={this.props.moduleId} radius={8}/>
                </div>
            </React.Fragment>
        );
    }

    onMediaCenterEdgeOffsetsChanged(sender, offsets)   {
        let animateBottom = OEAnimateHelper.animateBottom(offsets.animate);
        let animateAny = OEAnimateHelper.animateAny(offsets.animate);

        this.setState((prevState, props) => {
            let state = clone(prevState);
            state.mediaCenterEdgeOffsets = Object.assign(clone(offsets), {animate: prevState.mediaCenterEdgeOffsets.animate});

            state.bottomEdgeOffset.value = Math.max(offsets.bottom, state.bottomBarWidgetToolbarEdgeOffsets.bottom);

            state.edgeOffsets.right = Math.max(offsets.right, state.bottomBarWidgetToolbarEdgeOffsets.right);
            state.edgeOffsets.bottom = Math.max(offsets.bottom, state.bottomBarWidgetToolbarEdgeOffsets.bottom);

            if(OEToolbox.shallowEqual(state, prevState, true))  return prevState;

            state.mediaCenterEdgeOffsets.animate = offsets.animate;
            state.bottomEdgeOffset.animate = animateBottom;
            state.edgeOffsets.animate = OEAnimateHelper.update(state.edgeOffsets.animate, offsets.animate, {right: true, bottom: true});
            return state;
        });

        this.props.moduleEnv.component.uiStateManager.setState((prevState) => {
            let state = clone(prevState);
            state.mediaCenter.edgeOffsets = Object.assign(clone(offsets), {animate: prevState.mediaCenter.edgeOffsets.animate});

            state.bottomEdgeOffset.value = Math.max(offsets.bottom, state.bottomBarWidgetToolbar.edgeOffsets.bottom);

            state.edgeOffsets.right = Math.max(offsets.right, state.bottomBarWidgetToolbar.edgeOffsets.right);
            state.edgeOffsets.bottom = Math.max(offsets.bottom, state.bottomBarWidgetToolbar.edgeOffsets.bottom);

            if(OEToolbox.shallowEqual(state, prevState, true))  return prevState;

            state.mediaCenter.edgeOffsets.animate = animateAny;
            state.bottomEdgeOffset.animate = animateBottom;
            state.edgeOffsets.animate = animateAny;
            return state;
        });
    }

    onMediaCenterBottomBarEdgeOffsetsChanged(sender, offsets)   {
        let animateAny = OEAnimateHelper.animateAny(offsets.animate);

        this.setState((prevState, props) => {
            let state = clone(prevState);
            state.mediaCenterBottomBarEdgeOffsets = Object.assign(clone(offsets), {animate: prevState.mediaCenterBottomBarEdgeOffsets.animate});

            state.bottomBarEdgeOffsets = {top: 0, right: Math.max(offsets.right, state.bottomBarWidgetToolbarEdgeOffsets.right), bottom: Math.max(offsets.bottom, state.bottomBarWidgetToolbarEdgeOffsets.bottom), left: 0, animate: prevState.bottomBarEdgeOffsets.animate};

            if(OEToolbox.shallowEqual(state, prevState, true))  return prevState;

            state.mediaCenterBottomBarEdgeOffsets.animate = offsets.animate;
            state.bottomBarEdgeOffsets.animate = offsets.animate;
            return state;
        });

        this.props.moduleEnv.component.uiStateManager.setState((prevState) => {
            let state = clone(prevState);
            state.mediaCenter.bottomBar.edgeOffsets = Object.assign(clone(offsets), {animate: prevState.mediaCenter.bottomBar.edgeOffsets.animate});

            state.bottomBar.edgeOffsets = {top: 0, right: Math.max(offsets.right, state.bottomBarWidgetToolbar.edgeOffsets.right), bottom: Math.max(offsets.bottom, state.bottomBarWidgetToolbar.edgeOffsets.bottom), left: 0, animate: prevState.bottomBar.edgeOffsets.animate};

            if(OEToolbox.shallowEqual(state, prevState, true))  return prevState;

            state.mediaCenter.bottomBar.edgeOffsets.animate = animateAny;
            state.bottomBar.edgeOffsets.animate = animateAny;
            return state;
        });
    }

    onShouldBeVisibleLeftWidgetToolbar(visible, animated) {
        if(visible === this.leftWidgetToolbarShown) return;
        this.leftWidgetToolbarShown = visible;
        this.updateLeftSlideInContainer(animated);
    }

    onLeftWidgetToolbarResize(sender, size) {
        this.leftWidgetSizeObserver = sender;
        this.updateLeftSlideInContainer(false);
    }

    onMainMenuSizeChanged(sender, size)   {
        this.mainMenuWidth = size.w;

        this.props.moduleEnv.component.uiStateManager.updateState({mainMenu: {width : {$set: this.mainMenuWidth}}});
        this.updateLeftSlideInContainer(false);
    }

    onMainMenuControlBtnPressed()   {
        this.closeAllPopovers();
        this.showLeftSlideIn(!this.leftSlideInShown, true);
    }

    onBottomBarWidgetToolbarEdgeOffsetsChanged(offsets, animated)   {
        let animate = typeof(animated) === 'undefined' ? false : animated;

        this.setState((prevState, props) => {
            let state = clone(prevState);
            state.bottomBarWidgetToolbarEdgeOffsets = Object.assign(clone(offsets), {animate: prevState.bottomBarWidgetToolbarEdgeOffsets.animate});

            state.bottomBarEdgeOffsets = {top: 0, right: Math.max(offsets.right, state.mediaCenterBottomBarEdgeOffsets.right), bottom: Math.max(offsets.bottom, state.mediaCenterBottomBarEdgeOffsets.bottom), left: 0, animate: prevState.bottomBarEdgeOffsets.animate};

            state.bottomEdgeOffset.value = Math.max(offsets.bottom, state.mediaCenterEdgeOffsets.bottom);

            state.edgeOffsets.right = Math.max(offsets.right, state.mediaCenterEdgeOffsets.right);
            state.edgeOffsets.bottom = Math.max(offsets.bottom, state.mediaCenterEdgeOffsets.bottom);
            
            if(OEToolbox.shallowEqual(state, prevState, true))  return prevState;

            state.bottomBarWidgetToolbarEdgeOffsets.animate = animate;
            state.bottomBarEdgeOffsets.animate = animate;
            state.bottomEdgeOffset.animate = animate;
            state.edgeOffsets.animate = OEAnimateHelper.update(state.edgeOffsets.animate, animate, {right: true, bottom: true});
            return state;
        });

        this.props.moduleEnv.component.uiStateManager.setState((prevState) => {
            let state = clone(prevState);
            state.bottomBarWidgetToolbar.edgeOffsets = Object.assign(clone(offsets), {animate: prevState.bottomBarWidgetToolbar.edgeOffsets.animate});

            state.bottomBar.edgeOffsets = {top: 0, right: Math.max(offsets.right, state.mediaCenter.bottomBar.edgeOffsets.right), bottom: Math.max(offsets.bottom, state.mediaCenter.bottomBar.edgeOffsets.bottom), left: 0, animate: prevState.bottomBar.edgeOffsets.animate};

            state.bottomEdgeOffset.value = Math.max(offsets.bottom, state.mediaCenter.edgeOffsets.bottom);

            state.edgeOffsets.right = Math.max(offsets.right, state.mediaCenter.edgeOffsets.right);
            state.edgeOffsets.bottom = Math.max(offsets.bottom, state.mediaCenter.edgeOffsets.bottom);

            if(OEToolbox.shallowEqual(state, prevState, true))  return prevState;
            
            state.bottomBarWidgetToolbar.edgeOffsets.animate = animate;
            state.bottomBar.edgeOffsets.animate = animate;
            state.bottomEdgeOffset.animate = animate;
            state.edgeOffsets.animate = animate;
            return state;
        });
    }

    onPresentationControllerPinnedChanged(sender, pinned) {
        if(pinned)  this.closeAllPopovers(this.oe.Module.UIControllerType.presentation, true);
    }
}

OEUILayer.defaultProps = {
    moduleId:               '',
    className:              '',
    config:                 OEDefaultConfigFactory.uiLayer()
};

OEUILayer.propTypes = {
    moduleId:               PropTypes.string,
    className:              PropTypes.string,
    style:                  PropTypes.object,
    config: PropTypes.shape({
        mainMenuButtons:    OEMainMenu.propTypes.buttons,
        mainMenuConfig:     OEMainMenu.propTypes.config,
        widgetConfig:       PropTypes.object,
        hasMediaCenter:     PropTypes.bool,
        disableTutor:       PropTypes.bool
    }).isRequired
};

export default connectAppEnv((env) => { return {
    appComponent:           env.component,
    target:                 env.config.target,
    version:                env.config.version,
    config:                 env.config.module.uiLayerConfig
}})(addModuleEnv(OEUILayer));